export const MAX_CHARACTERS = 20000;
